import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { Trans } from "react-i18next/TransWithoutContext";

import { Section, SectionHeader } from "@roqua/components/sections";

import { DemographicsForm } from "@/components/DemographicsForm";
import { PageTitle } from "@/components/PageTitle";
import { BackButton } from "@/components/ui/BackButton";
import { RespondentsForDossier } from "@/features/RespondentEditor/queries";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute("/$organizationKey/$dossierId/dossier/demographics")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, dossierId } = useSessionContext();
  const { t } = useTranslation("RespondentEditor");
  const { data } = useSuspenseQuery(RespondentsForDossier, {
    variables: { organizationKey, dossierId },
  });
  const demographics = data.currentDossier.demographics;

  return (
    <>
      <PageTitle title="demographics" />
      <Section variant="header">
        <SectionHeader
          header={t("demographicsForm.header")}
          buttons={<BackButton href="/$organizationKey/$dossierId/dossier" />}
        />
      </Section>

      <Section>
        <p className="text-foreground mt-4">
          <Trans t={t} i18nKey="demographicsForm.description" />
        </p>

        <DemographicsForm demographics={demographics} />
      </Section>
    </>
  );
}
